export const productId = (id) => (id == null ? "" : String(id));

export const calculateOrderPrice = (outgoingItems, outgoingItemsMap, productsDocs = []) => {
  if (!outgoingItems?.length) return 0;

  return outgoingItems.reduce((total, item) => {
    const pid = productId(item._id);
    const product =
      outgoingItemsMap.get(pid) ??
      outgoingItemsMap.get(item._id) ??
      productsDocs.find((p) => productId(p._id) === pid);
    const unitPrice = Number(product?.price) || 0;
    const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
    return total + unitPrice * qty;
  }, 0);
};
